import { OrganisationIdAndNameOnly } from '@/types/organisation';
import { useOrganisationOverrideContext } from './use-organisation-override-context';
import { usePlatformAdminOrganisationOverride } from './use-platform-admin-organisation-override';
import { useUserOrganisation } from './use-user-organisation';

export type UseOrganisationReturn = {
  isUsingOrganisationOverride: boolean;
  organisation: OrganisationIdAndNameOnly | undefined;
};

export const useCurrentOrganisation = (): UseOrganisationReturn => {
  const { organisation: userOrganisation } = useUserOrganisation();
  const contextOverride = useOrganisationOverrideContext();

  let isUsingOrganisationOverride = false;
  let currentOrganisation = userOrganisation;

  const { data: organisationOverride } = usePlatformAdminOrganisationOverride();
  if (organisationOverride) {
    currentOrganisation = organisationOverride;
    isUsingOrganisationOverride = true;
  } else if (!currentOrganisation && contextOverride) {
    currentOrganisation = contextOverride;
  }

  return {
    isUsingOrganisationOverride,
    organisation: currentOrganisation,
  };
};
